import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Home from './components/Home/Home';
import Header from './components/layouts/Header';
import Footer from './components/layouts/Footer';
import About from './components/About';
import Contact from './components/Contact';
import Cart from './components/Cart/Cart';
import Shipping from './components/Cart/Shipping';
import ConfirmOrder from './components/Cart/ConfirmOrder';
import SuccessOrder from './components/Cart/SuccessOrder';
import Login from './components/Login';
import Profile from './components/Profile';
import MyOrders from './components/MyOrders/MyOrders';
import OrderDetails from './components/MyOrders/OrderDetails';
import Dashboard from './components/admin/Dashboard';

import './styles/app.scss';
import "./styles//home.scss";
import './styles/founder.scss'
import './styles/menu.scss';
import './styles/menuCard.scss';
import './styles/footer.scss';
import './styles/about.scss';
import './styles/contact.scss';
import './styles/cart.scss';
import './styles/shipping.scss';
import './styles/confirmOrder.scss';
import './styles/successOrder.scss';
import './styles/login.scss';
import './styles/profile.scss';
import './styles/table.scss';
import './styles/orderDetails.scss';
import './styles/dashborad.scss';


function App() {
  return <Router>
    <Header isAuthenticated={true}/>
    <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path='/about' element={<About/>} />
      <Route path='/contact' element={<Contact/>} />
      <Route path='/cart' element={<Cart/>} />
      <Route path='/shipping' element={<Shipping/>} />
      <Route path='/confirmorder' element={<ConfirmOrder/>} />
      <Route path='/successorder' element={<SuccessOrder/>} />
      <Route path='/login' element={<Login/>} />
      <Route path='/me' element={<Profile/>} />
      <Route path='/myorders' element={<MyOrders/>} />
      <Route path='/order/:id' element={<OrderDetails/>} />
      <Route path='/admin/dashboard' element={<Dashboard/>} />
    </Routes>
    <Footer/>
  </Router>
}

export default App;
